import React from "react";
import { Button, Icon, TileOptionsButton } from "aible";

import Select from "react-select";

import { Modal, Radio } from "react-bootstrap";

import { LineInput } from "components/Inputs/LineInput";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faUserPlus } from "@fortawesome/free-solid-svg-icons";

import FoldersMenuContainer from "containers/Folders/FoldersMenu";
import FoldersCreateContainer from "containers/Folders/FoldersCreate";

import { parseRoleType } from "containers/Folders/reducer";
import GearIcon from "images/gear-purple.svg";
import EditFolderIcon from "images/Pen to Square Icon.svg";
import CreateFolderIcon from "images/Light Folder Circle Plus.svg";
import AddUsersIcon from "images/user-plus-light.svg";

import { Dropdown, MenuItem } from "react-bootstrap";

import { isEnabled } from "utils/featureFlags";

import Tooltip from "components/Inputs/Tooltip";

import AccountView from "containers/View/Account";
import AccountTile from "components/Tiles/AccountTile";

import FolderPickerIcon from "images/folder-migrate.svg";

import styles from "./style.module.css";

export default class FoldersHeader extends React.Component {
  state = {
    showModal: false,
    editModal: false,
    permissionsModal: false,
    isProjectPicker: false
  };

  handleShow() {
    return this.setState({
      showModal: true
    });
  }

  handleHide() {
    return this.setState({
      showModal: false,
      editModal: false,
      permissionsModal: false
    });
  }

  render() {
    const {
      folders,
      users,
      roles,
      selectedFolder,
      createFolder,
      isTableauMode,
      isGoogleMode,
      projectFolderId,
      updateProjectFolderId
    } = this.props;
    const { showModal, editModal, permissionsModal, isProjectPicker } = this.state;

    const projectFolder = projectFolderId === undefined ? undefined : folders.find((f) => f.id === projectFolderId);

    const IS_SIMPLE_MODE = true;

    return (
      <div className={styles.foldersHeaderWrapper}>
        <div className={styles.foldersHeader}>
          <FolderSelect {...this.props} />
          {!isTableauMode && !isGoogleMode && !isEnabled("hide-sharing") && (
            <React.Fragment>
              {IS_SIMPLE_MODE ? (
                <Dropdown id="folderGear" style={{ display: "flex", flexWrap: "nowrap" }}>
                  <Dropdown.Toggle className={styles.folderGearButton}>
                    <img src={EditFolderIcon} style={{ width: "16px", marginTop: "0", marginRight: "-2px" }} />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <MenuItem
                      onClick={() => {
                        this.setState({ editModal: true, permissionsModal: false });
                      }}
                      className={styles.folderMenuItem}
                    >
                      <FolderMenuItem
                        icon={EditFolderIcon}
                        iconStyle={{ marginTop: "-6px", height: "20px" }}
                        itemText={"Edit Folder"}
                      />
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        this.setState({ permissionsModal: true, editModal: false });
                      }}
                      className={styles.folderMenuItem}
                    >
                      <FolderMenuItem
                        icon={AddUsersIcon}
                        iconStyle={{ marginTop: "-5px" }}
                        itemText={"Add Collaborators To This Folder"}
                      />
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        this.handleShow();
                      }}
                      className={styles.folderMenuItem}
                    >
                      <FolderMenuItem
                        icon={CreateFolderIcon}
                        iconStyle={{ marginTop: "-5px" }}
                        itemText={"Create New Folder"}
                      />
                    </MenuItem>
                  </Dropdown.Menu>
                </Dropdown>
              ) : (
                <React.Fragment>
                  <Tooltip trigger={["hover"]} overlay={"Edit Folder"}>
                    <Button
                      onClick={(e) => this.setState({ editModal: true, permissionsModal: false })}
                      className={styles.foldersHeaderEdit}
                    >
                      <Icon type={"editPurple"} size={20} />
                    </Button>
                  </Tooltip>
                  <Tooltip trigger={["hover"]} overlay={"Add Collaborators"}>
                    <Button
                      onClick={(e) => this.setState({ permissionsModal: true, editModal: false })}
                      className={styles.foldersHeaderEdit}
                    >
                      <Icon type={"userAddPurple"} size={20} />
                    </Button>
                  </Tooltip>
                  <Tooltip trigger={["hover"]} overlay={"Create New Folder"}>
                    <Button
                      onClick={() => this.handleShow()}
                      className={styles.foldersHeaderEdit}
                      // style={{ marginRight: "auto" }}
                    >
                      <Icon type={"folderAddPurple"} size={20} />
                    </Button>
                  </Tooltip>
                  {isEnabled("folder-project-picker") && !isEnabled("chat-aible-consumer") && (
                    <React.Fragment>
                      <Tooltip trigger={["hover"]} overlay={"Save Projects to another Folder"}>
                        <Button
                          onClick={() => this.setState({ isProjectPicker: !isProjectPicker })}
                          className={styles.foldersHeaderEdit}
                          style={{ marginRight: "auto" }}
                          active={isProjectPicker}
                        >
                          <img className={styles.folderPickerIcon} src={FolderPickerIcon} />
                        </Button>
                      </Tooltip>
                    </React.Fragment>
                  )}
                  {isEnabled("folder-project-picker") && isProjectPicker && (
                    <div className={styles.projectPicker}>
                      <Tooltip trigger={["hover"]} overlay={"Select Folder to save new Projects"}>
                        <div className={styles.picker}>
                          <Select
                            options={
                              folders
                                ? folders.map((f) => ({
                                    label: f.name,
                                    value: f.id
                                  }))
                                : []
                            }
                            onChange={(val) => updateProjectFolderId(val.value)}
                          />
                        </div>
                      </Tooltip>
                    </div>
                  )}
                </React.Fragment>
              )}
            </React.Fragment>
          )}
          <FoldersMenuContainer />
          <FoldersCreateContainer
            showModal={showModal || editModal || permissionsModal}
            isEdit={editModal}
            isManagePermissions={permissionsModal}
            id={(editModal || permissionsModal) && selectedFolder ? selectedFolder.id : undefined}
            handleHide={() => this.handleHide()}
          />
        </div>
      </div>
    );
  }
}

class FolderSelect extends React.PureComponent {
  handleSelect(option) {
    const { selectFolder } = this.props;
    if (option && option.value === "") {
      return;
    }
    if (option && option.value !== undefined) {
      return selectFolder && selectFolder(option.value);
    }
  }

  render() {
    const { folders, selectedFolder, selectFolder, setDefaultFolder, defaultFolderId, createHandler, userId } =
      this.props;

    // return this.renderOLD();

    const folderOptions =
      folders?.map((folder) => {
        const isDefault = folder.id === defaultFolderId;
        const radioColor = isDefault ? "#7E69D7" : undefined;
        const folderRole =
          folder.roles && folder.roles.find((role) => role.role_user && role.role_user.id === parseInt(userId));
        const folderRoleType = (folderRole && folderRole.role_type) || folder.default_role_type;
        return {
          isSelected: selectedFolder && selectedFolder.id === folder.id,
          value: folder.id,
          label: folder.name,
          isDefault: isDefault,
          roleType: parseRoleType(folderRoleType),
          selected: folder.name
        };
      }) ?? [];

    return (
      <div className={styles.folderSelect} id={"folderSelect"}>
        <Select
          placeholder={"Select a folder"}
          onChange={(option) => this.handleSelect(option)}
          value={folderOptions.find((o) => o.value === selectedFolder?.id)}
          styles={{
            menu: (provided) => ({ ...provided, zIndex: 1001 }),
            control: (provided, state) => ({
              ...provided,
              borderColor: state.isFocused ? "#5925DC" : provided.borderColor,
              boxShadow: state.isFocused ? "0px 0px 0px 1px #5925DC" : provided.boxShadow,
              "&:hover": {
                borderColor: "#5925DC",
                boxShadow: "0px 0px 0px 1px #5925DC"
              }
            })
          }}
          components={{
            Option: CustomOption
          }}
          options={[{ value: "", label: "" }, ...folderOptions]}
        />
      </div>
    );
  }
}

class CustomOption extends React.PureComponent {
  render() {
    const { value, label, innerProps, data } = this.props;

    const isDefault = data?.isDefault;
    const roleType = data?.roleType;
    const isSelected = data?.isSelected;

    if (value === "") {
      return (
        <div
          className={styles.folderSelectOption + " " + styles.folderSelectTitle + " " + styles.noHover}
          style={{ color: "#868595" }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className={styles.folderSelectOptionLabel}>{"Folder"}</div>
          <div className={styles.folderSelectOptionCloud}>{"Role"}</div>
        </div>
      );
    }

    return (
      <div className={styles.folderSelectOption + " " + (isSelected ? styles.isSelected : "")} {...innerProps}>
        <Tooltip trigger={["hover"]} overlay={label}>
          <div className={styles.folderSelectOptionLabel} title={label}>
            {label}
          </div>
        </Tooltip>
        <div className={styles.folderSelectOptionCloud + " " + styles.small} title={roleType}>
          {roleType}
        </div>
      </div>
    );
  }
}

const FolderMenuItem = ({ itemText, icon, iconStyle }) => {
  return (
    <div className={styles.folderItemWrapper}>
      <div className={styles.folderMenuIconWrapper} style={iconStyle}>
        <img className={styles.folderMenuIcon} src={icon} />
      </div>
      {itemText}
    </div>
  );
};
